import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PAYPAL_MOBILE_DEFAULT = createFcmConfig('paypal_mobile_default', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
